/*eslint-disable*/ export const messages = JSON.parse("{\"breadcrumbs.ariaLabel\":[\"Du er her\"]}");
//# sourceMappingURL=messages.mjs.map